import { Types } from "../actions/MailGroupsActions";

const initialState = {
    mailGroupList: {},
    error: [],
    isTaskUpdated: false,
};

export const MailGroupsReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_MAILGROUPS:
            return {
                ...state,
                mailGroupList: action.payload || state.mailGroupList,
            };
        case Types.SHOW_SNACK_MESSAGE:
            return {
                ...state,
                error: action.payload,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        default:
            return state;
    }
};
